import {Component, Host, h, Element, Prop, State} from '@stencil/core';
import ImageViewer from 'iv-viewer';

@Component({
  tag: 'z3-image-viewer',
  styleUrls: [
    'iv-viewer.css',
    'z3-image-viewer.css'
  ],
  shadow: true,
})
export class Z3ImageViewer {

  /**
   * Own Properties
   */
  img!: HTMLImageElement
  viewer!: ImageViewer

  /**
   * Host Element
   */
  @Element() host: HTMLElement;

  /**
   * Props
   */
  @Prop() src: string = '';
  @Prop() highResSrc: string = '';
  @Prop() zoomValue: number = 100;
  @Prop() maxZoom: number = 500;
  @Prop() snapView: boolean = true;
  @Prop() zoomStep: number = 50;
  @Prop() initialLeft: number = 50;
  @Prop() initialTop: number = 50;

  /**
   * States
   */
  @State() options: any = {
    zoomValue: 100, // It defines the initial zoom value of the image.
    maxZoom: this.maxZoom, // It defines the max limit for the zoom value of the image.
    snapView: this.snapView, // If true will show snap view.
    refreshOnResize: true, // Defines whether to refresh the viewer on resize of window. This is available only for Container and Image mode. On FullScreen mode it will refresh on window resize by default.
    zoomOnMouseWheel: true, // Defines weather to allow zoom with mouse scroll or not.
    hasZoomButtons: true, // Defines weather to add zoom buttons or not
    zoomStep: this.zoomStep, // The number of which the zoom should increase/decrease when the buttons are clicked
    listeners: {
      onInit: this.onInit,
      onImageLoaded: this.onImageLoaded,
      // onZoomChange: this.callback
    }
  };

  /**
   * Component lifecycle events
   */
  connectedCallback() {
  }

  componentDidRender() {
    // console.log('componentDidRender')
    if (!this.viewer) {
      if (window.innerWidth < 1024) {
        this.options.zoomValue = this.zoomValue
        this.viewer = new ImageViewer(this.img, this.options)
        setTimeout(() => {
          this.handleMoveTo(this.initialLeft, this.initialTop)
        }, 1000);
      }else {
        this.viewer = new ImageViewer(this.img, this.options)
      }
    }
  }
  handleZoomIn() {
    this.viewer.zoom(this.viewer._state.zoomValue + this.options.zoomStep)
  }

  handleZoomOut() {
    this.viewer.zoom(this.viewer._state.zoomValue - this.options.zoomStep)
  }
  handleMoveTo(left:number, top: number) {
    let container = this.viewer._elements.container
    let largeImage = this.viewer._elements.image
    let leftPx = (container.offsetWidth - largeImage.offsetWidth) * (left / 100)
    let topPx = (container.offsetHeight - largeImage.offsetHeight) * (top / 100)
    largeImage.style.left = leftPx + 'px'
    largeImage.style.top = topPx + 'px'
  }
  onInit() {
    // console.log('init')
  }
  onImageLoaded () {
    // console.log('img loaded')
  }

  callback (data:any) {
    console.log(data)
  }

  render() {
    return (
      <Host>
        <div class="image-viewer__wrapper">
          <img
            part="image"
            src={this.src}
            data-high-res-src={this.highResSrc}
            ref={(el) => this.img = el as HTMLImageElement}/>
          <div class="image-viewer__controls">
            <button
              part="zoom_in"
              onClick={() => this.handleZoomIn()}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
            </button>
            <button
              part="zoom_out"
              onClick={() => this.handleZoomOut()}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
              </svg>
            </button>
            <button
              part="zoom_reset"
              class="zoom-reset"
              onClick={() => this.viewer.resetZoom()}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24" height="24" >
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5" />
              </svg>
            </button>
          </div>
        </div>
      </Host>
    );
  }

}
